import React, { useEffect, useRef } from 'react';
import usePromocionesStore from '../../store/promocionesStore';

const VistaPreviaImagenes = () => {
    const refIframe = useRef(null);
    const { datos, imagen } = usePromocionesStore();
    
    const enviarImagenFlutter = () => {
      refIframe.current.contentWindow.postMessage(
        { tipo: 'imagen_promocion', payload: JSON.stringify({
        texto_uno: datos.texto_uno,
        texto_dos: datos.texto_dos,
        imagen: imagen.replace(/^data:image\/\w+;base64,/, ""),
        hexFondo: datos.hexFondo.replace('#', ''),
        hexTexto: datos.hexTexto.replace('#', '')
        }) },
        'https://cms.jphoteles.com.mx/promocion_imagenes' // debe coincidir exactamente
      );
    }

    useEffect(() => {
      enviarImagenFlutter();
    }, [datos,imagen]);
    
    return (
        <div className="col-md-3" style={{ width: '370px', height: 'auto', }}>
            <label style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'center',width: '100%',color: '#000' }}>Vista previa app</label>
            <div
                style={{
                width: '370px',
                height: '700px',
                background: '#222',
                borderRadius: '40px',
                border: '8px solid #222',
                boxShadow: '0 0 24px 2px #888',
                padding: '16px 8px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                }}
            >
                {/* Botón superior tipo "notch" */}
                <div
                style={{
                    width: '60px',
                    height: '8px',
                    background: '#444',
                    borderRadius: '8px',
                    margin: '0px auto 15px auto',
                }}
                />
                <iframe
                ref={refIframe}
                src="https://cms.jphoteles.com.mx/promocion_imagenes"
                width="100%"
                height="680px"
                title="Vista previa"
                style={{
                    border: 'none',
                    borderRadius: '20px',
                    background: '#fff',
                    boxShadow: '0 0 0 2px #ccc',
                }}
                ></iframe>
            </div>
        </div>
    )
}

export default VistaPreviaImagenes
